import Tag from 'shared-web/src/components/Tag'
import cx from 'classnames'
import { Button } from '@driftt/tide-core-legacy'
import { Link } from 'react-router'
import IconSVG from 'svg-inline-react'

import pictureDrawingSrc from '!svg-inline?removeTags=true!images/svg/picture-drawing.svg'
import UIDropArea from 'components/shared/UIDropArea'
import UserSelect from 'components/UserSelect'
import LoadingDots from 'components/shared/LoadingDots'
import TinyEditor from '../TinyEditor'
import Card from '../Card'

import twitter from 'images/svg/twitter.svg'
import linkedin from 'images/svg/linkedin.svg'
import facebook from 'images/svg/facebook.svg'

import './style.styl'


export const EmailEditCard = ({
  title = "Email",
  description,
  onDeleteClick,
  narrowHeader,
  includeSenderSelect,
  senderName,
  onHeadlineChange,
  headline,
  message,
  onMessageChange,
  placeholderName,
  emailOverride,
  actions: { fetchEmbed, fetchOrg },
  embedFetchPending,
  dynamicAccountSendAttribute,
  onSenderNameChange,
  onUserIdChange,
  selectedUserId = null,
  renderSelectedUser,
  includeInboxEmails = true,
  hasDynamicSenderEnabled,
  sendTestLoading = false,
  onSendTestEmailClick,
  showInlineTestEmail = false,
  showCompanyLogo,
  showHeroImage,
  showCompanyFooter,
  orgLogoUrl,
  orgName,
  orgTwitterUrl,
  orgLinkedinUrl,
  orgFacebookUrl,
  orgAddress,
  onBannerUpload,
  bannerImageUrl,
  onBannerClear,
  isOrgLoaded,
  isBannerUploadPending,
  defaultUser,
  onEditSenderClick,
}) => (
  <div className="playbook-message">
    <Card
      title={title}
      description={!!description ? description : headline}
      className={cx("drift-form", "playbook-email-message-edit", { "padded-email-edit-card": !hasDynamicSenderEnabled })}
      onDeleteClick={onDeleteClick}
      narrowHeader={narrowHeader}
    >
      {includeSenderSelect &&
       !hasDynamicSenderEnabled &&
        <div className="playbook-email-edit-card-non-dynamic-header">
          <div className="playbook-edit-message-heading">Sender Name and Email</div>
          <input
            className="playbook-email-message-input-stacked"
            type="text"
            onChange={onSenderNameChange}
            value={senderName}
            placeholder="Sender name"
          />
          <UserSelect
            selectedUserId={selectedUserId}
            onUserIdChange={onUserIdChange}
            renderOption={user => (!!user.name ? `${user.email} (${user.name})` : user.email)}
            renderSelectedValue={renderSelectedUser}
            includeInboxEmails={includeInboxEmails}
          />
          <div className="playbook-edit-message-heading">Subject Line</div>
          <input type="text" className={cx({ ["playbook-edit-message-subject-input"]: showInlineTestEmail })} onChange={onHeadlineChange} value={!!description ? description : headline} />
          {showInlineTestEmail &&
            <Button type="tertiary" onClick={onSendTestEmailClick} loading={sendTestLoading}>Send Test Email</Button>
          }
        </div>
      }
      {includeSenderSelect &&
       hasDynamicSenderEnabled &&
        <div className="playbook-email-edit-card-top">
          <div className="playbook-email-edit-card-sender">
            <span className="playbook-email-edit-card-header">Sender</span>
            {dynamicAccountSendAttribute ?
              <Tag className="playbook-email-edit-dynamic-sender-attrib" tag={{ name: `{{ account.${dynamicAccountSendAttribute} }}` }} /> :
              <span>{senderName || placeholderName} &lt;{emailOverride || defaultUser.email}&gt;</span>
            }
            <a onClick={onEditSenderClick} className="playbook-email-edit-card-sender-edit-link">edit</a>
          </div>
          <div className="playbook-email-edit-card-subject">
            <span className="playbook-email-edit-card-header">Subject</span>
            <input className="playbook-email-edit-card-subject-input" placeholder="[No Subject] - Required" type="text" onChange={onHeadlineChange} value={!!description ? description : headline} />
            {showInlineTestEmail &&
              <Button type="tertiary" size="small" onClick={onSendTestEmailClick} loading={sendTestLoading}>Send Test Email</Button>
            }
          </div>
        </div>
      }
      {showCompanyLogo &&
        <div className="playbook-email-edit-header-image">
          {!!orgLogoUrl &&
            <img src={orgLogoUrl} />
          }
          {!!!orgLogoUrl &&
            <p>You do not have company logo in your Drift account.</p>
          }
          <div className="playbook-email-edit-header-meta">
            <Link target="_blank" className="playbook-email-edit-meta-link" to="/settings/company">Edit Logo</Link>
            |
            <span
              className="playbook-email-edit-meta-link playbook-email-edit-meta-refresh-header"
              onClick={fetchOrg}
            >
              Refresh Logo{!isOrgLoaded && <span className="playbook-email-edit-loading"><LoadingDots /></span>}
            </span>
          </div>
        </div>
      }
      {showHeroImage &&
        <div className="playbook-email-edit-header-image">
          <UIDropArea
            onDrop={onBannerUpload}
            onClear={onBannerClear}
            shouldRenderClear={false}
            shouldRenderPreview={false}
            className="playbook-email-edit-banner-drop-area"
          >
            {bannerImageUrl &&
              <img src={bannerImageUrl} />
            }
            {!bannerImageUrl &&
              <div className="playbook-email-edit-banner-drop-zone">
                <div>
                  <span className="playbook-email-edit-empty-banner-icon">
                    <IconSVG src={pictureDrawingSrc} width={"20px"} />
                  </span>
                  {!isBannerUploadPending &&
                  <div>
                    <div className="playbook-email-edit-banner-title">Add a banner image.</div>
                    <div className="playbook-email-edit-banner-title">Drag and drop or <span className="link">Upload</span></div>
                  </div>
                  }
                  {isBannerUploadPending &&
                    <div>
                      <div className="playbook-email-edit-banner-title">Uploading your banner image.</div>
                      <div className="playbook-email-edit-banner-upload-loading-container"><LoadingDots /></div>
                    </div>
                  }
                </div>
                <div className="playbook-edit-banner-help-text">
                  <p>Keep in mind that your image will be scaled to 600px wide in the email.</p>
                </div>
              </div>
            }
          </UIDropArea>
          {bannerImageUrl &&
            <Button className="playbook-email-edit-banner-clear" type="secondary" onClick={onBannerClear}>Clear Image</Button>
          }
        </div>
      }
      <TinyEditor initialContent={message} onChange={onMessageChange} noOuterBorder={hasDynamicSenderEnabled} showCtaInsert={true} />
      {showCompanyFooter &&
        <div className="playbook-email-edit-footer">
          <div className="playbook-email-edit-social-links">
            {!!orgTwitterUrl &&
              <a target="_blank" href={orgTwitterUrl}><img src={twitter}/></a>
            }
            {!!orgLinkedinUrl &&
              <a target="_blank" href={orgLinkedinUrl}><img src={linkedin} /></a>
            }
            {!!orgFacebookUrl &&
              <a target="_blank" href={orgFacebookUrl}><img src={facebook} /></a>
            }
          </div>
          <div className="playbook-email-edit-footer-text">{orgName}</div>
          <div className="playbook-email-edit-footer-text playbook-email-edit-footer-text-small">{orgAddress}</div>
          <div className="playbook-email-edit-footer-text-muted"><a>Click here to unsubscribe</a></div>
          <div className="playbook-email-edit-footer-meta">
            <Link className="playbook-email-edit-footer-meta-link" target="_blank" to="/settings/company">Edit Footer</Link>
            |
            <span className="playbook-email-edit-footer-meta-link" onClick={() => fetchEmbed()}>Refresh Footer{embedFetchPending && <span className="playbook-email-edit-loading"><LoadingDots /></span>}</span>
          </div>
        </div>
      }
    </Card>
  </div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailEditCard/component.js